import { z } from 'zod';

import { currencyAccountSchema } from '@/entities/currency-account/model/schemas';

export const exchangeFormSchema = z.object({
  fromCurrency: currencyAccountSchema,
  toCurrency: currencyAccountSchema,
  fromAmount: z.number(),
  toAmount: z.number(),
  rate: z.number(),
  fee: z.number(),
  lastEditedSide: z.enum(['from', 'to']).default('from'),
});

export type ExchangeFormValues = z.infer<typeof exchangeFormSchema>;
